import {useProfileInfoBoxQuery} from '#apollo/schema';
import RectangleSkeleton from '#component/base/skeletons/RectangleSkeleton';
import {sprinkles} from '#style/sprinkles';

import CouponBox from './components/CouponBox/CouponBox';
import PaymentInfoBox from './components/PaymentInfoBox/PaymentInfoBox';
import ShippingAddressBox from './components/ShippingAddressBox/ShippingAddressBox';

import {infoBoxesWrapper} from './InfoBoxes.css';

const InfoBoxes = () => {
  const userInfo = useProfileInfoBoxQuery();
  const {data, loading} = userInfo ?? {};
  const {me} = data ?? {};
  const {userProfile, customerAccount} = me ?? {};
  const {firstName, lastName} = userProfile ?? {};
  const {shippingAddress, paymentMethods, subscription} = customerAccount ?? {};

  const paymentMethod = subscription?.paymentMethodId
    ? paymentMethods?.find(method => method.id === subscription.paymentMethodId)
    : null;

  return !loading ? (
    <div className={infoBoxesWrapper}>
      {shippingAddress && (
        <ShippingAddressBox
          firstName={firstName ?? ''}
          lastName={lastName ?? ''}
          shippingAddress={shippingAddress}
        />
      )}
      {paymentMethod && <PaymentInfoBox paymentMethod={paymentMethod} />}
      {subscription && <CouponBox subscription={subscription} />}
    </div>
  ) : (
    <div className={sprinkles({flex: 'flex', dir: ['col', 'row'], content: 'between'})}>
      <RectangleSkeleton width={400} height={300} />
      <RectangleSkeleton width={400} height={300} />
      <RectangleSkeleton width={400} height={300} />
    </div>
  );
};

export default InfoBoxes;
